import React, { useCallback, useMemo } from "react";
import type { TabsProps } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { ITabs } from "./Interfaces/ITabs";
import { StyledNavTabs } from "./Tabs.styles";

export const Tabs: React.FC<ITabs> = ({ tabs }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const activeKey = useMemo(() => {
        const match = tabs.find((t) => location.pathname.includes(t.path));
        return match?.path ?? tabs[0]?.path;
    }, [location.pathname, tabs]);

    const items: TabsProps["items"] = useMemo(
        () =>
            tabs.map((tab) => ({
                key: tab.path,
                label: tab.name,
                disabled: tab.disabled,
            })),
        [tabs],
    );

    const onChange = useCallback(
        (key: string) => {
            const tab = tabs.find((t) => t.path === key);
            if (!tab || tab.disabled) return;
            navigate(key);
            tab.callback?.();
        },
        [navigate, tabs],
    );

    if (tabs.length === 0 || !activeKey) {
        return null;
    }

    return <StyledNavTabs activeKey={activeKey} items={items} onChange={onChange} />;
};
